export default __webpack_public_path__ + "static/media/explore6.564f70c8.png";